import type { Parceiro } from "./tipos"

// A Faz Cred é o parceiro padrão e não declara tema: as cores dela são as de `index.css`, que é
// onde o Tailwind precisa encontrá-las para gerar as classes. Um parceiro só descreve o que muda.
export const FAZ_CRED: Parceiro = {
    slug: "fazcred",
    nome: "Faz Cred",
    doParceiro: "da Faz Cred",
    comArtigo: "a Faz Cred",
    tituloDaAba: "Faz Cred · Portal do Empregador",
    marca: {
        tipo: "imagem",
        claro: "/brand/faz-cred.svg",
        escuro: "/brand/faz-cred-branco.svg",
        alt: "Faz Cred",
    },
    dominios: [],
    operadoPelaFazCred: false,
}
